exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.transfer-confirm__subject-field[data-v-08026e8c] {\n  padding-top: 0;\n}\n.transfer-confirm__inner[data-v-08026e8c] {\n  padding: .75rem 1.2rem 0;\n}\n.withdrawal-cashbox__row[data-v-08026e8c],\n.withdrawal-daily-limit[data-v-08026e8c] {\n  color: rgba(191, 190, 190, 0.5);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-08026e8c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/topupBalance/make/TopupBalance.Confirm.vue
// module id = DBHG
// module chunks = 1